/**
 * Dependencies.
 */
import { BaseModel, endpoint } from '@prz-dp/services';

import CollectModel from '@/api/collect/collect.model';
import DeliveryModel from '@/api/delivery/delivery.model';
import DriverModel from '@/api/driver/driver.model';
import RequestModel from '@/api/request/request.model';
import TrackingModel from '@/api/tracking/tracking.model';
import VehicleModel from '@/api/vehicle/vehicle.model';

/**
 * Export `OrderTrackingModel`.
 */
@endpoint('deliveryTracking')
export default class OrderTrackingModel extends BaseModel {
  /**
   * Properties.
   */
  betweenFromDate: string;

  betweenToDate: string;

  canCreateRequests: boolean;

  canShowVehicle: boolean;

  collect?: CollectModel;

  delivery?: DeliveryModel;

  deliverySurvey?: {
    alreadySubmited: boolean;
  };

  distributionCenter: {
    code: string;
    name: string;
    timeZone: string;
  };

  driver: DriverModel;

  numberPackages?: number;

  orderProcessDelayed?: boolean;

  orderType: 'DELIVERY' | 'COLLECT';

  requestPendingTreatment: {
    changeAddress: boolean;
    changeDate: boolean;
    changeDateAndAddress: boolean;
    contact: boolean;
    message: boolean;
  };

  requests?: RequestModel[];

  route: {
    code: string;
    startDate: string;
  };

  servicePointOrderPin?: string;

  servicePointRetentionTime?: number;

  tracking: TrackingModel[];

  vehicle: VehicleModel;

  /**
   * Constructor.
   */
  constructor(data: Partial<OrderTrackingModel>) {
    super(data);
  }
}
